import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: '#f9f9f9',
    boxShadow: 'inset 0 -2px 0 #00a78f'
  },
  headCheck: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    width: '5%',
    color: '#4B4952',
    top: 0,
    zIndex: 2
  },
  headStatus: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '10%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headName: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '25%',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    '@media all and (max-width: 900px)': {
      display: 'none'
    }
  },
  headRoleUser: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '25%',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headTypeComercial: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '25%',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },

  headTypeUser: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '25%',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 2
  },
  headKebab: {
    borderTop: 'none !important',
    borderBottom: 'none !important',
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#4B4952',
    width: '5%',
    textAlign: 'start',
    position: 'sticky',
    top: 0,
    zIndex: 2
  }
}))

export default useStyles
